import i18n from "i18next";
import { i18nextPlugin } from "translation-check";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next)
  .use(i18nextPlugin)
  .init({
    resources: {
      en: {
        translation: {
          privacy: "Privacy",
          footer: {
            bookCall: "Book a call back",
            chatNow: "Chat now",
            callNow: "Call {{phoneNumber}}",
            chatIsStillLoading:
              "The Chat is still loading, try again in a little bit",
          },
          start: {
            title: "Help customers find your business.",
            subTitle:
              "Complete the form below to generate an estimate of your marketing budget within a few minutes that is tailored to your type of business and location.",
            name: "Name",
            namePlaceholder: "John Smith",
            email: "Email",
            emailPlaceholder: "jsmith@mail.com",
            phoneNumber: "Phone Number",
            phoneNumberPlaceholder: "(02) 1234 5678",
            businessName: "Business name",
            businessNamePlaceholder: "John's Company ltd.",
            businessCategorySelection: "Business category selection",
            businessCategorySelectionPlaceholder: "Thai Restaurant",
            town: "Town",
            townPlaceholder: "Melbourne",
            labelTC: "I want to be notified about the results. ",
            validations: {
              requiredField: "This field is required",
              invalidEmail: "This email is invalid",
            },
            generateEstimateAction: "Generate estimate",
            estimateFailedError:
              "We do not have sufficient data for this town and business category combination. Please try a town near your selection or try a different category that matches closely.",
          },
          wait: {
            title: "While you wait...",
            subTitle: `Did you know, there are 40,000 Google searches every second. Businesses that don't utilise online marketing are missing opportunities to reach more customers and grow their business.`,
            waitEstimate:
              "It may take up to 60 seconds to generate your marketing estimate.",
          },
          estimate: {
            title: "Campaign Estimate Tool.",
            subTitle:
              "To increase your reach to potential customers, simply move the needle to increase your marketing spend.",
            potentialViews: "Potential Ad Views",
            potentialClicks: "Potential Clicks",
            to: "to",
            emailSentBefore: "An email has been sent to",
            emailSentAfter: "with a summary of this estimate.",
            estimateInfo:
              "This Marketing Estimate Tool is intended to be indicative. The estimate provided should be used as a guide. We cannot guarantee the number of Ad Views and Clicks for the marketing spend you input into this tool.",
            seeAdsAction: "See what your ads could look like",
            bookAppointmentAction: "Book an appointment",
            refreshEstimateAction: "Refresh Estimate",
          },
          preview: {
            title: "Ad preview.",
            subTitle:
              "The images below are an example of what your online ads could look like. Images and content will be changed based on your reqirements.",
            socialLabel: "Social",
            searchLabel: "Search",
            social: {
              companyName: "Company name",
              sponsored: "Sponsored",
              description: "Description",
              path: "Company Website Url",
              mainHeadline: "Headline",
              subHeadline: "Subline",
              contactUs: "Contact us",
              like: "Like",
              comment: "Comment",
              share: "Share",
            },
            search: {
              search: "Search",
              clearSearch: "Clear search",
              reportPredictions: "Report inappropriate predictions",
              allTabLabel: "All",
              videosTabLabel: "Videos",
              imagesTabLabel: "Images",
              newsTabLabel: "News",
              mapsTabLabel: "Maps",
              booksTabLabel: "Books",
              searchTools: "Search tools",
              headline: "Headline",
              ad: "Ad",
              path: "Company Website Url",
              description: "Description",
              sitelinkName: "Sitelink Name",
              phoneNumber: "Phone number",
            },
          },
          callback: {
            title: "Book a call back.",
            subTitle:
              "Arrange for one of our Telstra Business Website Services team members to give you a call.",
            name: "Name",
            namePlaceHolder: "John Smith",
            phoneNumber: "Phone Number",
            phoneNumberNumber: "0400 000 000",
            validations: {
              requiredField: "This field is required",
              invalidNumber: "This number is invalid",
              invalidDate: "This date is invalid",
              invalidTime: "This time is invalid",
            },
            preferredDate: "Preferred date",
            preferredDatePlaceholder: "DD/MM/YYYY",
            preferredTime: "Preferred time",
            preferredTimePlaceholder: "- Please select -",
            bookNowAction: "Book now",
            successMessage: "Call back request received successfully.",
            errorMessage: "Something went wrong, pelase try again.",
          },
          notFound: {
            title: "Page not found!",
            goToStartAction: "Get me out of here",
          },
        },
      },
    },
    lng: "en",
    debug: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });
